import ai_light from "../assets/vendAI_light.png";
import ai_dark from "../assets/vendAI_dark.png";
import vendaiFavicon from "../assets/favicon.ico";
import { API_HOST, UI_HOST,API_USERS_HOST } from "../config/api";

export const TENANTS = {
  "vendai.lettaiot.com": {
    name: "VENDAI",
    title: "VendAI",
    projectCode: "VENDAI",
    favicon: vendaiFavicon,
    textStyle: {
      fontWeight: "bold",
      fontSize: "2rem",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "text.primary",
    },
    theme: {
      primary: "#F5F5F7",
      logoLight: ai_light,
      logoDark: ai_dark,
    },
    apiBaseUrl: UI_HOST,
  },
  "vendai2.lettaiot.com": {
    name: "VENDAI",
    title: "VendAI",
    projectCode: "VENDAI",
    favicon: vendaiFavicon,
    textStyle: {
      fontWeight: "bold",
      fontSize: "2rem",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "text.primary",
    },
    theme: {
      primary: "#F5F5F7",
      logoLight: ai_light,
      logoDark: ai_dark,
    },
    apiBaseUrl: API_HOST,
  },
  "vendbox.lettaiot.com": {
    name: "VAOYS",
    title: "VAOYS",
    projectCode: "VAOYS",
    textStyle: {
      fontWeight: "bold",
      fontSize: "2rem",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "text.primary",
    },
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: UI_HOST,
  },
  "wwms.lettaiot.com": {
    name: "WWMS",
    title: "WWMS",
    projectCode: "WWMS",
    textStyle: {
      fontWeight: "normal",
      fontSize: "2rem",
      letterSpacing: "0.05em",
      textTransform: "capitalize",
      color: "text.primary",
    },
    theme: {
      primary: "#F5F5F7",
      // logoLight: lightLogo,
      // logoDark: darkLogo,
    },
    apiBaseUrl: API_HOST,
  },
  default: {
    name: "LettaIoT",
    title: "LettaIoT",
    // logoLight: ai_light,
    // logoDark: ai_dark,
    projectCode: "",
    textStyle: {
      fontWeight: "600",
      fontSize: "2rem",
      letterSpacing: "0.02em",
      textTransform: "none",
      color: "text.primary",
    },
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: UI_HOST,
  },
};

export const TENANT_PATH_CONFIG = {
  VAOYS: "vending-machines",
  VENDAI: "vending-machines",
  WWMS: "places",
  DEFAULT: "vending-machines",
};

/**
 * Get current tenant configuration based on hostname
 * @returns {Object} Tenant configuration
 */
export const getCurrentTenant = () => {
  const hostname = window.location.hostname;

  if (TENANTS[hostname]) {
    return TENANTS[hostname];
  }

  if (hostname.endsWith(".lettaiot.com")) {
    const subdomain = hostname.split(".")[0];

    return {
      name: subdomain.toUpperCase(),
      projectCode: subdomain.toUpperCase(),
      textStyle: {
        fontWeight: "bold",
        fontSize: "2rem",
        letterSpacing: "0.1em",
        textTransform: "uppercase",
      },
      theme: {
        primary: "#1976d2",
        // logoLight: lightLogo,
        // logoDark: darkLogo,
      },
      apiBaseUrl: API_HOST,
    };
  }

  return TENANTS["default"];
};
